module.exports = __webpack_public_path__ + "img/fecha_pago.17d63f06.svg";